export var LOAD_USER = '[Auth] Load User';
export var LOAD_USER_SUCCESS = '[Auth] Load User Success';
export var LOGIN_USER = '[Auth] Login User';
export var LOGOUT_USER = '[Auth] Logout User';
export var LOGIN_USER_SUCCESS = '[Auth] Login User Success';
export var LOGIN_USER_FAIL = '[Auth] Login User Fail';
export var NOT_AUTHENTICATED = '[Auth] Not Authenticated';
var LoginUser = /** @class */ (function () {
    function LoginUser(payload) {
        this.payload = payload;
        this.type = LOGIN_USER;
    }
    return LoginUser;
}());
export { LoginUser };
var LoadUser = /** @class */ (function () {
    function LoadUser() {
        this.type = LOAD_USER;
    }
    return LoadUser;
}());
export { LoadUser };
var LoadUserSuccess = /** @class */ (function () {
    function LoadUserSuccess(payload) {
        this.payload = payload;
        this.type = LOAD_USER_SUCCESS;
    }
    return LoadUserSuccess;
}());
export { LoadUserSuccess };
var LoginUserFail = /** @class */ (function () {
    function LoginUserFail(payload) {
        this.payload = payload;
        this.type = LOGIN_USER_FAIL;
    }
    return LoginUserFail;
}());
export { LoginUserFail };
var UserNotAuthenticated = /** @class */ (function () {
    function UserNotAuthenticated() {
        this.type = NOT_AUTHENTICATED;
    }
    return UserNotAuthenticated;
}());
export { UserNotAuthenticated };
var LogoutUser = /** @class */ (function () {
    function LogoutUser() {
        this.type = LOGOUT_USER;
    }
    return LogoutUser;
}());
export { LogoutUser };
var LoginUserSuccess = /** @class */ (function () {
    function LoginUserSuccess(payload) {
        this.payload = payload;
        this.type = LOGIN_USER_SUCCESS;
    }
    return LoginUserSuccess;
}());
export { LoginUserSuccess };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/actions/auth.actions.ts.pre-build-optimizer.js